import { useEffect, useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { excludeNullOrUndefined } from 'checkout/utils'
import * as Analytics from 'analytics/analytics'
import { clientEvent } from 'analytics/snowplow/events'

export default function useSearchResultStatsTrack(listKey: string) {
  const listMeta = useAppSelector(state => state.offer.searchResultMetadata.offerMetaData[listKey])

  const listStats = useMemo(() => {
    if (listMeta) {
      const offerMetas = Object.values(listMeta).filter(excludeNullOrUndefined)
      const visibleOffers = offerMetas.filter(meta => !meta.hiddenByDefault)
      const allCount = visibleOffers.length
      const flashCount = visibleOffers.filter(meta => meta.type === 'hotel').length
      const lpcCount = visibleOffers.filter(meta => meta.type === 'tactical_ao_hotel').length
      const bedbankCount = visibleOffers.filter(meta => meta.kind === 'bedbank').length
      const hiddenCount = offerMetas.length - allCount
      return {
        allCount,
        flashCount,
        lpcCount,
        bedbankCount,
        hiddenCount,
      }
    }
  }, [listMeta])

  useEffect(() => {
    if (listStats) {
      Analytics.track(
        'client-event',
        clientEvent({
          subject: 'search-result-all-count',
          action: `ab-value: ${listStats.allCount}`,
          category: 'logging',
          type: 'operational',
          optimizelyEventId: '29291120532',
          optimizelyEventKey: 'search-result-all-count',
        }),
      )
      Analytics.track(
        'client-event',
        clientEvent({
          subject: 'search-result-flash-count',
          action: `ab-value: ${listStats.flashCount}`,
          category: 'logging',
          type: 'operational',
          optimizelyEventId: '29212190437',
          optimizelyEventKey: 'search-result-flash-count',
        }),
      )
      Analytics.track(
        'client-event',
        clientEvent({
          subject: 'search-result-lpp-count',
          action: `ab-value: ${listStats.bedbankCount}`,
          category: 'logging',
          type: 'operational',
          optimizelyEventId: '29289900202',
          optimizelyEventKey: 'search-result-lpp-count',
        }),
      )
      Analytics.track(
        'client-event',
        clientEvent({
          subject: 'search-result-lpc-count',
          action: `ab-value: ${listStats.lpcCount}`,
          category: 'logging',
          type: 'operational',
          optimizelyEventId: '29266330606',
          optimizelyEventKey: 'search-result-lpc-count',
        }),
      )
    }
  }, [listStats])
}
